module.exports = __webpack_public_path__ + "static/media/invoiceActivity.b6afe234.jpg";